import { transitionTravelInsuranceQuoteForm } from '../../../actions/travelKe/quote';
import { getQuoteForm } from '../../../selectors/travelKe/quote';
import { FIELD_STATUS } from '../../../reducers/status';

export const quoteFormRules = (store, next, action) => {
    const result = next(action);
    const quoteForm = getQuoteForm(store.getState());
    const quoteFormValid = validateQuoteForm(quoteForm);
    const formAction = quoteFormValid
        ? transitionTravelInsuranceQuoteForm.formValid()
        : transitionTravelInsuranceQuoteForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateQuoteForm = (formFields) => {
    return (
        // formFields?.tripType?.status === FIELD_STATUS.VALID &&
        // formFields?.coverFor?.status === FIELD_STATUS.VALID &&
        formFields?.departureCountry?.status === FIELD_STATUS.VALID &&
        formFields?.destinationCountry?.status === FIELD_STATUS.VALID &&
        formFields?.departureDate?.status === FIELD_STATUS.VALID &&
        formFields?.returnDate?.status === FIELD_STATUS.VALID &&
        (formFields?.noOfMinors?.status === FIELD_STATUS.VALID ||
            formFields?.noOfAdults?.status === FIELD_STATUS.VALID ||
            formFields?.noOfSeniors?.status === FIELD_STATUS.VALID ||
            formFields?.noOfSeniors76?.status === FIELD_STATUS.VALID ||
            formFields?.noOfSeniors81?.status === FIELD_STATUS.VALID) &&
        formFields?.dob?.status === FIELD_STATUS.VALID
    );
};
